// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2MjnJ","messages":"Chat_messages__3gG2E","dateDivider":"Chat_dateDivider__1hetA"};